"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Default data for `MaterialTable.options` attribute
 */
var _default = {
  actionsColumnIndex: 0,
  addRowPosition: 'last',
  columnsButton: false,
  detailPanelType: 'multiple',
  debounceInterval: 200,
  doubleHorizontalScroll: false,
  emptyRowsWhenPaging: true,
  exportAllData: false,
  exportMenu: [],
  filtering: false,
  groupTitle: false,
  header: true,
  headerSelectionProps: {},
  hideFilterIcons: false,
  loadingType: 'overlay',
  padding: 'default',
  searchAutoFocus: false,
  paging: true,
  pageSize: 5,
  pageSizeOptions: [5, 10, 20],
  paginationType: 'normal',
  paginationPosition: 'bottom',
  showEmptyDataSourceMessage: true,
  showFirstLastPageButtons: true,
  showSelectAllCheckbox: true,
  search: true,
  showTitle: true,
  showTextRowsSelected: true,
  showDetailPanelIcon: true,
  tableLayout: 'auto',
  toolbarButtonAlignment: 'right',
  searchFieldAlignment: 'right',
  searchFieldStyle: {},
  searchFieldVariant: 'standard',
  selection: false,
  selectionProps: {},
  sorting: true,
  keepSortDirectionOnColumnSwitch: true,
  toolbar: true,
  defaultExpanded: false,
  detailPanelColumnAlignment: 'left',
  detailPanelOffset: {
    left: 0,
    right: 0
  },
  thirdSortClick: true,
  overflowY: 'auto'
};
exports["default"] = _default;